
const { ccclass, menu, property, executeInEditMode, inspector, requireComponent } = cc._decorator;

const misc = cc.misc

@ccclass
@menu('custom/GapProgressBar')
@executeInEditMode
export default class GapProgressBar extends cc.ProgressBar {


    @property([cc.Node])
    gap_items: cc.Node[] = []

    _updateBarStatus() {
        if (this.barSprite) {
            var entity = this.barSprite.node;

            if (!entity) return;

            var progress = misc.clamp01(this.progress);
            let maxCount = Math.max(1, Math.floor(this.totalLength)) 
            let curCount = Math.round(maxCount * progress)
            this.showGap(curCount)
        }
    }

    protected showGap(count: number){
        if(this.barSprite){
            if(this.gap_items.length == 0){
                this.gap_items.push(this.barSprite.node)
            }
            for (let index = 0; index < this.gap_items.length; index++) {
                const element = this.gap_items[index];
                element.active = false
            }
            for (let index = 0; index < count; index++) {
                let element = this.gap_items[index];
                if(!element){
                    element = this.gap_items[index] = this.genGap()
                }
                element.active = true
            }
        }
    }

    protected genGap(){
        let node = this.barSprite.node
        let newNode = cc.instantiate(node)
        newNode.parent = node.parent   
        return newNode     
    }

}